export default __webpack_public_path__ + "static/media/gallery (2).ecf4da28.png";